export default __webpack_public_path__ + "static/media/completed-chk.e9583b09.svg";